import { FC, ReactNode } from "react";
import StepsLayout from "@funded-here-interface/common/src/Layouts/StepsLayoutIndividual/StepsLayout";
import { useStyles } from "./IndividualInvestor.styles";
import { ToastContainer } from "react-toastify";
import NavBar from "../../components/NavBar/NavBar";

interface IProps {
  content: ReactNode;
  showSteps?: boolean;
  step: number;
}

const IndividualInvestor: FC<IProps> = ({ content, showSteps, step }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.mainContainer}>
      <NavBar />
      <ToastContainer />

      {showSteps && <StepsLayout currentStep={step} />}
      <div className={classes.stepContainer}>{content}</div>
    </div>
  );
};

export default IndividualInvestor;
